import React from "react"
import { selectAviaSearchCurrency } from "../../../../../app/reducers/book/aviaSearchSlice"
import { useSelector } from "react-redux"
import { useTranslation, Trans } from "react-i18next"

const DateModalFooter = () => {
  const { t } = useTranslation()
  const currency = useSelector(selectAviaSearchCurrency)

  return (
    <div className="relative pt-1 pb-2 px-4">
      <div className="absolute bottom-8 left-4 right-4 border-b border-dashed border-light-gray/25"></div>
      <p className="text-[13px]">
        <Trans
          i18nKey="admin.displaying_prices"
          components={{
            currency: <span className="text-dark-orange" />,
          }}
          values={{ currency }}
        />{" "}
        <span className="text-dark-orange">Кишинёв — Барселона</span>
      </p>
    </div>
  )
}

export default DateModalFooter
